import {defineSlotRecipe} from '@chakra-ui/react3'

export const TOAST_STATUS_VARIANT_MAP = {
    success: 'success',
    error: 'error',
    warning: 'error',
    info: 'default',
    default: 'default'
}

export const toastSlotRecipe = defineSlotRecipe({
    slots: ['root', 'header', 'title', 'description', 'indicator', 'closeTrigger', 'actionTrigger'],
    className: 'chakra-toast',
    base: {
        root: {
            display: 'flex',
            flexDirection: 'column',
            position: 'relative',
            gap: 'spacing-12',
            py: 'spacing-12',
            ps: 'spacing-12',
            pe: 'spacing-40',
            borderRadius: 'l2',
            boxShadow: 'md',
            width: '23.4375rem',
            maxWidth: 'calc(100vw - 2rem)',
            translate: 'var(--x) var(--y)',
            scale: 'var(--scale)',
            zIndex: 'var(--z-index)',
            height: 'var(--height)',
            opacity: 'var(--opacity)',
            willChange: 'translate, opacity, scale',
            transition:
                'translate 400ms, scale 400ms, opacity 400ms, height 400ms, box-shadow 200ms',
            transitionTimingFunction: 'cubic-bezier(0.21, 1.02, 0.73, 1)',
            _closed: {
                transition: 'translate 400ms, scale 400ms, opacity 200ms',
                transitionTimingFunction: 'cubic-bezier(0.06, 0.71, 0.55, 1)'
            }
        },
        header: {
            display: 'flex',
            alignItems: 'flex-start',
            gap: 'spacing-8',
            width: 'full'
        },
        title: {
            flex: '1',
            minWidth: 0,
            textStyle: 'heading.small',
            color: 'inherit',
            wordBreak: 'break-word',
            '& a': {
                textDecoration: 'underline',
                textUnderlineOffset: '{spacing.spacing-8}',
                color: 'inherit'
            }
        },
        description: {
            width: 'full',
            textStyle: 'body.small',
            color: 'inherit',
            wordBreak: 'break-word',
            '& a': {
                textDecoration: 'underline',
                textUnderlineOffset: '{spacing.spacing-8}',
                color: 'inherit'
            }
        },
        indicator: {
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0,
            boxSize: '5',
            mt: '0.125rem'
        },
        actionTrigger: {
            display: 'inline-flex',
            alignItems: 'center',
            width: 'fit-content',
            textStyle: 'body.small',
            color: 'inherit',
            textDecoration: 'underline',
            textUnderlineOffset: '{spacing.spacing-8}',
            background: 'transparent',
            border: 'none',
            padding: 0,
            cursor: 'pointer',
            '& a, & button': {
                display: 'inline-flex',
                alignItems: 'center',
                textStyle: 'body.small',
                textDecoration: 'underline',
                textUnderlineOffset: '{spacing.spacing-8}',
                color: 'inherit',
                background: 'transparent',
                border: 'none',
                padding: 0,
                cursor: 'pointer'
            }
        },
        closeTrigger: {
            position: 'absolute',
            top: 'spacing-12',
            right: 'spacing-12',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            bg: 'transparent',
            border: 'none',
            p: 'spacing-2',
            m: '-spacing-2',
            borderRadius: 'l1',
            _icon: {
                strokeWidth: '1.5'
            },
            _focusVisible: {
                outline: '2px solid',
                outlineOffset: '2px'
            }
        }
    },
    variants: {
        variant: {
            default: {
                root: {
                    bg: 'primary.base.black',
                    color: 'text.primary-inverted'
                },
                indicator: {
                    bg: 'transparent',
                    color: 'icons.primary-inverted'
                },
                closeTrigger: {
                    color: 'icons.on-color',
                    _focusVisible: {
                        outlineColor: 'border.strong-inverted'
                    }
                }
            },
            success: {
                root: {
                    bg: 'background.system.success-light',
                    color: 'text.primary'
                },
                indicator: {
                    bg: 'transparent',
                    color: 'icons.system.success-on-surface'
                },
                closeTrigger: {
                    color: 'icons.primary',
                    _focusVisible: {
                        outlineColor: 'border.strong'
                    }
                }
            },
            error: {
                root: {
                    bg: 'background.system.error-light',
                    color: 'text.primary'
                },
                indicator: {
                    bg: 'transparent',
                    color: 'icons.system.error-on-surface'
                },
                closeTrigger: {
                    color: 'icons.primary',
                    _focusVisible: {
                        outlineColor: 'border.strong'
                    }
                }
            }
        }
    },
    defaultVariants: {
        variant: 'default'
    }
})
